import { FillRoleContent } from "../../parts/fill_role_content";
import { useIsPotentiallyOverbooked } from "../../parts/use_is_potentially_overbooked";
import { RequestApprovalModalStepProps } from "../types";

export const RequestApprovalModalStepOne = ({
  engagement,
  exception,
  shortlistItem,
  role
}: RequestApprovalModalStepProps) => {
  const { profile } = shortlistItem;

  const { isOverbooked, isFetching } = useIsPotentiallyOverbooked({
    profileId: profile.id,
    activityId: role.id
  });

  return (
    <FillRoleContent
      engagement={engagement}
      profile={profile}
      shouldShowSoftOverbooking={isOverbooked}
      exception={exception}
      isFetching={isFetching}
    />
  );
};
